/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropDiscordChannel } from './DropDiscordChannel';
import {
    DropDiscordChannelFromJSON,
    DropDiscordChannelFromJSONTyped,
    DropDiscordChannelToJSON,
    DropDiscordChannelToJSONTyped,
} from './DropDiscordChannel';

/**
 * 
 * @export
 * @interface DropDiscordWidget
 */
export interface DropDiscordWidget {
    /**
     * 
     * @type {string}
     * @memberof DropDiscordWidget
     */
    guildId: string;
    /**
     * 
     * @type {string}
     * @memberof DropDiscordWidget
     */
    guildName: string;
    /**
     * 
     * @type {number}
     * @memberof DropDiscordWidget
     */
    presenceCount: number;
    /**
     * 
     * @type {string}
     * @memberof DropDiscordWidget
     */
    instantInvite?: string;
    /**
     * 
     * @type {Array<DropDiscordChannel>}
     * @memberof DropDiscordWidget
     */
    channels?: Array<DropDiscordChannel>;
}

/**
 * Check if a given object implements the DropDiscordWidget interface.
 */
export function instanceOfDropDiscordWidget(value: object): value is DropDiscordWidget {
    if (!('guildId' in value) || value['guildId'] === undefined) return false;
    if (!('guildName' in value) || value['guildName'] === undefined) return false;
    if (!('presenceCount' in value) || value['presenceCount'] === undefined) return false;
    return true;
}

export function DropDiscordWidgetFromJSON(json: any): DropDiscordWidget {
    return DropDiscordWidgetFromJSONTyped(json, false);
}

export function DropDiscordWidgetFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropDiscordWidget {
    if (json == null) {
        return json;
    }
    return {
        
        'guildId': json['guildId'],
        'guildName': json['guildName'],
        'presenceCount': json['presenceCount'],
        'instantInvite': json['instantInvite'] == null ? undefined : json['instantInvite'],
        'channels': json['channels'] == null ? undefined : ((json['channels'] as Array<any>).map(DropDiscordChannelFromJSON)),
    };
}

export function DropDiscordWidgetToJSON(json: any): DropDiscordWidget {
    return DropDiscordWidgetToJSONTyped(json, false);
}

export function DropDiscordWidgetToJSONTyped(value?: DropDiscordWidget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guildId': value['guildId'],
        'guildName': value['guildName'],
        'presenceCount': value['presenceCount'],
        'instantInvite': value['instantInvite'],
        'channels': value['channels'] == null ? undefined : ((value['channels'] as Array<any>).map(DropDiscordChannelToJSON)),
    };
}

